/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { 
  Box, 
  CircularProgress,  
  Table, 
  TableBody, 
  TableCell, 
  TableFooter, 
  TableHead, 
  TablePagination, 
  TableRow, 
  TableSortLabel, 
  Typography 
} from '@mui/material';

import TablePaginationActions from '../../../../../components/utils/TablePaginationActions';
import useTablePaginationInit from '../../../../../components/hooks/useTablePaginationInit';
import TopBar from '../../../../../components/utils/TopBar';

const OverviewPage = () => {
  const state = useSelector(state => state["business.core"]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const [billingList, setBillingList] = useState([]);
  const [billingTotal, setBillingTotal] = useState(0);

  const [
    page, 
    rowsPerPage, 
    handleChangePage, 
    handleChangeRowsPerPage
  ] = useTablePaginationInit();

  const tableHeadingsList = [
    {
      label: "Id",
      sort: "company_id",
    },
    {
      label: "Name",
      sort: "company_name",
    },
    {
      label: "Tenant",
      sort: "tanent_id",
    },
    // {
    //   label: "Orum Id",
    //   sort: "orum_id",
    // },

    {
      label: "Wyzia Campaign Id",
      sort: "wy_campaign_id",
    },
    {
      label: "Wyzia Campaign Access Key",
      sort: "wy_campaign_access_key",
    },
    {
      label: "Wyzia Reserve Amount",
      sort: "wy_reserve_amount",
    },
    {
      label: "CC Account Id",
      sort: "cc_account_id"
    },
    {
      label: "Time stamps",
      sort: "created_at",
    },
    {
      label: "",
      sort: null
    }
  ];

  const handleSort = (value) => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    setSort(value);
  };

  useEffect(() => {
    // handleGetComspanies();
    // if(statusFilter === "Pay"){
    //   handleGetBillingPay();
    // } else if (statusFilter === "Get Paid"){ 
    //   handleGetBillingReceive();
    // } else if (statusFilter === "Wallet"){
    //   handleGetBillingDomesticWallet();
    // } else {}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, search, sort, sortDirection]);

  useEffect(() => {
    try {
      // formatCompaniesList(state.companiesList.records || []);
      // setCompaniesTotal(state.companiesList.total || 0);
    } catch (err) {}
  }, [state]);

  // const formatCompaniesList = (list) => {
  //   setCompaniesList(list)
  // };

  async function handleGetBlnkWallets(customLoading) {
    let query = ""
    if(search) query += `&search=${search}`;
    if(sort) query += `&ordering=${sortDirection === "asc" ? '' : '-'}${sort}`;
    // await dispatch(GetCompaniesBIZcore(page+1, rowsPerPage, query, true, customLoading ? customLoading : setLoading));
  };

  return (
    <Box>

      <TopBar
        title={"Billing"}
        search={search}
        onSearchChange={(e) => {
          setSearch(e.target.value);
        }}
        />

      {
        loading
        ?
        <Box height={"300px"} className="flexCenterCenterRow">
          <CircularProgress />
        </Box>
        :
          billingList.length === 0
          ?
          <Box height={"300px"} className="flexCenterCenterRow">
            <Typography>No billing found</Typography>
          </Box>
          :
          <Table className="block">
            <TableHead>
              <TableRow>
                {
                  tableHeadingsList.map((heading, headingIndex) => (
                    heading.sort === null
                    ?
                    <TableCell
                      key={headingIndex}>{heading.label}</TableCell>
                    :
                    <TableCell
                      key={headingIndex}>
                      <TableSortLabel
                        active={sort === heading.sort ? true : false}
                        direction={sortDirection}
                        onClick={() => {
                          handleSort(heading.sort);
                        }}
                      >
                        {heading.label}
                      </TableSortLabel>
                    </TableCell>
                  ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {
                billingList.map((row, index) => (
                  <TableRow 
                    key={index}>
                    {/* <TableCell>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        <Copyable>
                          {row.company_id || <NA />}
                        </Copyable>
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Copyable>
                        {row.company_name || <NA />}
                      </Copyable>
                    </TableCell>
                    <TableCell>
                      <Typography>{row?.tanent_id?.tenant_name || <NA />}</Typography>
                      <Typography
                        variant='caption'
                        color={"grey"}>
                        {row?.tanent_id?.tenant_id || <NA />}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.wy_campaign_id || <NA />}</TableCell>
                    <TableCell>{row.wy_campaign_access_key || <NA />}</TableCell>
                    <TableCell>{handleShowAmount("USD", row.wy_reserve_amount || 0) || <NA />}</TableCell>
                    <TableCell>{row.cc_account_id || <NA />}</TableCell>
                    <TableCell>
                      <TableTimeStamps
                        createdAt={row.created_at}
                        updatedAt={row.updated_at}
                        />
                    </TableCell>
                    <TableCell>
                      <Box 
                        className="flexCenter_Row"
                        gap={"20px"}>
                        <IconButton>
                          <LoginOutlinedIcon sx={{ color: global['secondary_light'] }}/>
                        </IconButton>
                        <IconButton
                          onClick={(e) => {
                            e.stopPropagation()
                            setCompaniesMenuAnchor(e.currentTarget);
                            setCompaniesMenuOpen(true);
                            setUpdate(row);
                            setModalTitle(row.name || "");
                          }}>
                          <MoreVertIcon sx={{ color: global['secondary_light']}}/>
                        </IconButton>
                      </Box>
                    </TableCell> */}
                  </TableRow>
                ))
              }
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{ borderBottom: 0 }}
                  rowsPerPageOptions={[5, 10, 25, 50, 100]} 
                  colSpan={10}
                  count={billingTotal}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  />
              </TableRow>
            </TableFooter>
          </Table>
      }
    </Box>
  )
}

export default OverviewPage;